import React from "react";
import "./index.css";
import { Button, Col, Input, Label } from "reactstrap";
interface IEngagementModal {
  packageDeatils?: any;
  selectePackage?: any;
  setselectedPackage?: any;
  fetchCourseDetails?: any;
  toggle?: any;
}
function EngagementPackageModal({
  packageDeatils,
  selectePackage,
  setselectedPackage,
  fetchCourseDetails,
  toggle,
}: IEngagementModal) {
  console.log(packageDeatils, "packageDeatils");
  const handleSelectePackage = () => {
    toggle();
    fetchCourseDetails(selectePackage);
  };
  const handleSelectedPackage = (e: any) => {
    const filteredpackages = packageDeatils.filter(
      (el: any) => el.id == e.target.value
    );
    setselectedPackage(filteredpackages[0]);
  };

  const handleSelectedPackageOnDiv = (e: any, item: any) => {
    const filteredpackages = packageDeatils.filter(
      (el: any) => el.id == item.id
    );
    setselectedPackage(filteredpackages[0]);
  };
  return (
    <div className="w-100 d-flex flex-column justify-content-start align-items-center">
      <div className="w-100 mb-2">
        {packageDeatils.map((el: any, index: number) => {
          return (
            <div
              className="radio-button-package-selection"
              key={index}
              onClick={(e: any) => {
                handleSelectedPackageOnDiv(e, el);
              }}
            >
              <Label
                className="label-package-selection"
                check={selectePackage ? selectePackage.id == el.id : undefined}
              >
                {el.title}
              </Label>
              <Input
                name="package"
                type="radio"
                className="form-check-input-engagement"
                value={el.id}
                checked={
                  selectePackage ? selectePackage.id == el.id : undefined
                }
                onChange={(e: any) => {
                  handleSelectedPackage(e);
                }}
              />{" "}
            </div>
          );
        })}
      </div>
      <Col className="w-100 mt-3 mb-3 d-flex justify-content-center align-items-center">
        <Button
          color="aeslPrimary"
          className="btn-width-package-selection"
          onClick={() => {
            handleSelectePackage();
          }}
        >
          Done
        </Button>
      </Col>
    </div>
  );
}

export default EngagementPackageModal;
